import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRef } from "react";
import "./Error.css";
import logo from "../../assets/images/logo.png";

const errorContent = {
  400: {
    label: "Unable to complete request",
    title: "We couldn’t process that request.",
    message: "Some information may be missing or invalid. Please review your entries and try again.",
  },
  401: {
    label: "Session ended",
    title: "Your session has expired.",
    message: "For your security, please return to the login page and sign in again.",
  },
  403: {
    label: "Access unavailable",
    title: "This page isn’t available to you.",
    message:
      "Your account may not have permission to view this information. Contact your administrator if you need access.",
  },
  404: {
    label: "Page unavailable",
    title: "We couldn’t find that page.",
    message: "The page may have been moved, renamed, or is no longer available.",
  },
  500: {
    label: "Temporary interruption",
    title: "We hit an unexpected roadblock.",
    message:
      "Pronto couldn’t complete your request. Your information may still be saved, so please wait a moment and try again.",
  },
};

export const Error = () => {
  const { statusCode = "500" } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const error = errorContent[statusCode] || errorContent[500];

  const errorReference = useRef(location.state?.errorReference || `PRONTO-${statusCode}`).current;

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <main className="error-page">
      <section className="error-shell">
        <header className="error-header">
          <img className="error-logo" src={logo} alt="Pronto" />

          <div className="error-status">
            <span className="error-status__dot" />
            System notification
          </div>
        </header>
  
        <div className="error-layout">
          <div className="error-content">
            <div className="error-eyebrow">
              <span className="error-eyebrow__icon" aria-hidden="true">
                !
              </span>
              {error.label}
            </div>

            <h1 className="error-title">{error.title}</h1>

            <p className="error-message">{error.message}</p>

            <div className="error-actions">
              <button type="button" className="error-button error-button--primary" onClick={handleRetry}>
                <span className="error-button__refresh" aria-hidden="true">
                  ↻
                </span>
                Try again
              </button>

              <button
                type="button"
                className="error-button error-button--secondary"
                onClick={() => navigate("/home", { replace: true })}
              >
                Return to home
              </button>
            </div>

            <button type="button" className="error-back-link" onClick={() => navigate(-1)}>
              <span aria-hidden="true">←</span>
              Go back to the previous page
            </button>
          </div>
        </div>

        <footer className="error-footer">
          <div className="error-reference">
            <span className="error-reference__icon" aria-hidden="true">
              i
            </span>

            <div>
              <span className="error-reference__label">Reference ID</span>
              <strong>{errorReference}</strong>
            </div>
          </div>

          <p className="error-support">
            Still having trouble? Contact your system administrator and provide the reference ID.
          </p>
        </footer>
      </section>
    </main>
  );
};
